import React from 'react'
import logo from '../assets/logo.svg'

const Header: React.FC = () => {
  return (
    <div className="ocbc-header">
      <div className="container">
        <div className="ocbc-logo">
          <img src={logo} alt="Logo" className="brand-logo" />
          <div className="logo-text">
            <span className="brand-subtitle">每一次精准计算，都是对新生命的祝福与守护。</span>
          </div>
        </div>
        <div className="internal-use-notice">
          <i className="fas fa-building" />
          <span>内部使用系统</span>
        </div>
      </div>
    </div>
  )
}

export default Header
